export default __webpack_public_path__ + "media/images/temporary/fun-trees-e850cca16c7909e19695e2074464e3f9.jpg";